import Vue from 'vue';
import Vuetify from 'vuetify/lib';

import {
    mdiAccount,
    mdiLock,
    mdiTwoFactorAuthentication,
    mdiArrowExpandAll,
    mdiArrowLeft,
    mdiCached,
    mdiCalendar,
    mdiCheck,
    mdiCheckAll,
    mdiChevronDown,
    mdiClose,
    mdiDotsHorizontal,
    mdiFaceAgent,
    mdiGrid,
    mdiInformation,
    mdiLockSmart,
    mdiMagnify,
    mdiMap,
    mdiPencil,
    mdiPlayCircle,
    mdiPlus,
    mdiShareVariant,
    mdiMapMarker,
    mdiCamera,
    mdiCloseCircle,
    mdiCheckboxMarkedCircleOutline,
    mdiEyeOutline,
    mdiEyeOffOutline,
    mdiCrosshairsGps,
    mdiScanHelper,
    mdiViewList,
    mdiViewModule,
    mdiViewDay,
    mdiAccountCircle,
    mdiDownload,
    mdiInformationOutline,
    mdiCellphone,
    mdiWatch,
    mdiChevronRight,
    mdiChevronLeft,
    mdiMusicNoteOutline,
    mdiMapMarkerRadius,
    mdiAirplane,
    mdiDelete,
    mdiCheckCircleOutline
} from '@mdi/js';

Vue.use(Vuetify);

export default new Vuetify({
    icons: {
        iconfont: 'mdiSvg',
        values: {
            mdiAccount,
            mdiLock,
            mdiTwoFactorAuthentication,
            mdiArrowExpandAll,
            mdiArrowLeft,
            mdiCached,
            mdiCalendar,
            mdiCheck,
            mdiCheckAll,
            mdiChevronDown,
            mdiClose,
            mdiDotsHorizontal,
            mdiFaceAgent,
            mdiGrid,
            mdiInformation,
            mdiLockSmart,
            mdiMagnify,
            mdiMap,
            mdiPencil,
            mdiPlayCircle,
            mdiPlus,
            mdiShareVariant,
            mdiMapMarker,
            mdiCamera,
            mdiCloseCircle,
            mdiCheckboxMarkedCircleOutline,
            mdiEyeOutline,
            mdiEyeOffOutline,
            mdiCrosshairsGps,
            mdiScanHelper,
            mdiViewList,
            mdiViewModule,
            mdiViewDay,
            mdiAccountCircle,
            mdiDownload,
            mdiInformationOutline,
            mdiCellphone,
            mdiWatch,
            mdiChevronRight,
            mdiChevronLeft,
            mdiMusicNoteOutline,
            mdiMapMarkerRadius,
            mdiAirplane,
            mdiDelete,
            mdiCheckCircleOutline
        },
    },
    theme: {
        themes: {
            light: {
                primary: '#009688',
                secondary: '#0877DB',
                accent: '#0D2A48',
                subtitle: '#9397A7',

                error: '#FF5252',
                info: '#2196F3',
                success: '#4CAF50',
                warning: '#FFC107',
            },
        },
    },
});
